import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {GetForingLang, GetInterfaceLang, getStatiPageStats, AddStaticPage, getStaticPage, delPage, getStaticPageOne, getPageFilter} from '../../actions/index';

class StaticPage extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props) {
        super(props);
        this.renderTooltip = this.renderTooltip.bind(this);
        this.AddPage = this.AddPage.bind(this);
        this.renderSelectFilter = this.renderSelectFilter.bind(this);
        this.renderPage = this.renderPage.bind(this);
        this.editPage = this.editPage.bind(this);
        this.delPageOpenModal = this.delPageOpenModal.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.delPageInModal = this.delPageInModal.bind(this);
        this.filterInput = this.filterInput.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        this.props.GetInterfaceLang(token);
        this.props.getStatiPageStats();
        this.props.getStaticPage(token);
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();
    }
    addOpenModal(){
        $('#addPage').modal('show');
    }
    closeModal(id, item){
        $('#'+id).modal('hide');
    }
    removeClass(e){
        $(e.target).parent().removeClass('has-error');
    }
    delPageInModal(){
        let token = localStorage.getItem('id_token_admin');
        this.props.delPage(token, this.props.static_page.page_one.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal('delPage');
                $('input[name="word"]').val('')
                this.props.static_page.page_one = {};
                this.props.getStatiPageStats();
                this.props.getStaticPage(token);
            }
        });
    }
    filterInput(e){
        if(e.target.name == 'woblang'){
            $('select[name="wblang"]').val('selectDefault')
        }
        if(e.target.name == 'wblang'){
            $('select[name="woblang"]').val('selectDefault')
        }
        let token = localStorage.getItem('id_token_admin');
        let data = {
            inner_name: $('input[name="word"]').val(),
            woblang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : '',
            wblang: $('select[name="wblang"]').val() != 'selectDefault' ? $('select[name="wblang"]').val() : ''
        }

        this.props.getPageFilter(token, data);
        $('.selectpicker').selectpicker('refresh')
    }
    editPage(id, item){
        this.context.router.push('/static_page/edit/'+id+'/');
    }
    delPageOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        this.props.getStaticPageOne(token, id);
        $('#delPage').modal('show');
    }
    AddPage(){
        let token = localStorage.getItem('id_token_admin');
        if($('#inner_name').val() != ''){
            let obj ={
                inner_name: $('#inner_name').val()
            };
            this.props.AddStaticPage(token, obj).then((response)=>{
                if(response.payload.status == 201){
                    $('#addPage').modal('hide');
                    this.context.router.push('/static_page/edit/'+response.payload.data.id+'/');
                }else{
                    $('.error-paragraf').show();
                }
            });
        }else{
            $('#inner_name').parent().addClass('has-error');
        }
    }
    renderTooltip(){
        let that = this;
        return this.props.lang.interface_lang.results.map((item)=>{
            return that.props.static_page.stats.map((stat)=>{
                if(item.id == stat.blang){
                    let string = stat.translated+ ' / ' +stat.total;
                    return(
                        <p key={item.id} className="pull-left info-item" data-toggle="tooltip" data-placement="top" title={string} >{item.lang.name}</p>
                    )
                }
            });
        })
    }
    renderSelectFilter(id){
        this.props.lang.interface_lang.results.forEach((item)=>{
            if($('#'+id).find('option#'+item.id).length){
                return false
            }else{
                $('#'+id).append($('<option>', {
                    value: item.id,
                    text : item.lang.name,
                    id : item.id
                }));
            }
        });
        $('.selectpicker').selectpicker('refresh')
    }
    renderIcon(item){
        let that = this;
        return item.map((code)=>{
            if(code.content != '<p><br></p>' && code.content != '') {
                return that.props.lang.interface_lang.results.map((lang) => {
                    if(lang.id == code.blang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    renderPage(){
        return this.props.static_page.pages.results.map((item, i)=>{
            return (
                <div className="white-block common-list two clearfix" key={item.id}>
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span onClick={this.editPage.bind(this, item.id)}>{item.inner_name}</span>
                        {this.props.lang.interface_lang && this.props.lang.interface_lang.results && this.props.lang.interface_lang.results.length>0 ? this.renderIcon(item.translations) : ""}
                    </p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editPage.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delPageOpenModal.bind(this, item.id, item.flang)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <p className="pull-left">Static pages</p>
                        <button onClick={this.addOpenModal} type="button" className="pull-right btn btn-primary">
                            <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            Add page
                        </button>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block ">
                                <div className="clearfix static-header-buttons">
                                    <p className="pull-left">Translate to</p>
                                    <div className="block-info-group">
                                        {this.props.lang.foring_lang.results && this.props.lang.interface_lang.results && this.props.static_page.stats && this.props.static_page.stats.length>0 ? this.renderTooltip() : ""}
                                    </div>
                                </div>
                                <div className="separate-horizontal"> </div>
                                <div className="clearfix">
                                    <div className="col-md-6">
                                        <div className=" input-group search_block">
                                            <span className="input-group-addon glyphicon glyphicon-search"></span>
                                            <input type="search" name="word" className="form-control" placeholder="Search" onChange={this.filterInput}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-half pull-left mr20">
                                            <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Without translation into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.interface_lang.results ? this.renderSelectFilter('Without') : ""}
                                            </select>
                                        </div>
                                        <div className="input-half pull-left">
                                            <select className="selectpicker" name="wblang" id="into" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Translated into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.interface_lang.results ? this.renderSelectFilter('into') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.static_page.pages.results && this.props.static_page.pages.results.length > 0 ?
                            <div>
                                <div className="col-md-12">
                                    <div className="common-list two clearfix">
                                        <p>#</p>
                                        <p>Name</p>
                                        <p className="pull-right">Option</p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {this.renderPage()}
                                </div>
                            </div>
                            :
                            <div className={this.props.static_page.pages.results && this.props.static_page.pages.results.length < 0 || $.isEmptyObject(this.props.static_page.pages) ? "for_preloader" : 'for_preloader dn'}>
                                <div className="preloader-wrapper big active">
                                    <div className="spinner-layer spinner-blue-only">
                                        <div className="circle-clipper left">
                                            <div className="circle" />
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle" />
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.props.static_page.pages.results && this.props.static_page.pages.results.length === 0  && <p className="noResults">No items result</p>}
                    </div>


                    <div className="modal fade" id="addPage" tabIndex="-1" role="dialog" aria-labelledby="addPageLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal.bind(this, 'addPage')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <h3 className="title">Add page</h3>
                                </div>
                                <div className="modal-body">
                                    <div className="add_page_modal">
                                        <label htmlFor="inner_name">Name page</label>
                                        <input type="text" id="inner_name" name="inner_name" className="form-control" onChange={this.removeClass}/>
                                    </div>
                                    <p className="error-paragraf">Static page with this name already exists</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal.bind(this, 'addPage')} type="button" className="btn btn-default">Cancel</button>
                                    <button onClick={this.AddPage} type="button" className="btn btn-primary">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="delPage" tabIndex="-1" role="dialog" aria-labelledby="DelPageLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal.bind(this, 'delPage')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#delPage"></span>
                                    <p>Do you really want to delete this page {this.props.static_page.page_one ? <span>{this.props.static_page.page_one.inner_name}</span> : "" }?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal.bind(this, 'delPage')} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delPageInModal} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        static_page: state.static_page
    }
}


export default connect(mapStateToProps, {GetForingLang, GetInterfaceLang, getStatiPageStats, AddStaticPage, getStaticPage, getStaticPageOne, delPage, getPageFilter})(StaticPage);


// WEBPACK FOOTER //
// ./src/components/static_page/list.js